import { FC } from "react";
import { MainListItemStyled } from "@/shared";

export const CategoriesListNoData: FC = () => {
  return <MainListItemStyled>No categories</MainListItemStyled>;
};
